export const TEMPLATE_PREVIEW_CONTENT = {
  couple_names: 'João & Maria',
  slug: 'joaoemaria',
  wedding_date: '2026-08-15',
  ceremony_time: '15:00',
  reception_time: '15:00',
  ceremony_location: 'Villa Riso',
  ceremony_address: 'Estr. da Gávea, 728 - São Conrado, Rio de Janeiro - RJ, 22610-001',
  reception_location: 'Villa Riso',
  reception_address: 'Estr. da Gávea, 728 - São Conrado, Rio de Janeiro - RJ, 22610-001',
  same_location: true,
  story_text:
    'Nossa história começou de um jeito simples, mas cheio de significado. Entre conversas, sorrisos e encontros que pareciam pequenos ao olhar de fora, nasceu algo muito maior do que imaginávamos: uma conexão verdadeira, leve e especial.\n\nCom o tempo, descobrimos um no outro não apenas amor, mas também parceria, amizade e a certeza de que queríamos caminhar juntos. Foram muitos momentos compartilhados, aprendizados, sonhos divididos e memórias que construíram a base do que somos hoje.\n\nCada etapa da nossa jornada nos trouxe até aqui, até esse capítulo tão importante das nossas vidas. E agora, com o coração cheio de amor e gratidão, celebramos tudo o que vivemos e tudo o que ainda vamos viver.',
  hero_image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=1920',
  gallery_position: 'after_story',
  gallery_images: [
    'https://images.unsplash.com/photo-1529636798458-92182e662485?w=1400',
    'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=1400',
    'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1400',
    'https://images.unsplash.com/photo-1507504031003-b417219a0fde?w=1400',
    'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=1400',
    'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=1400'
  ],
  confirmed_guests: 12,
  show_countdown: true,
  show_rsvp_count: true,
  show_gift_section: true,
  gifts: [
    {
      gift_id: 'preview-lua-de-mel',
      name: 'Cota Lua de Mel',
      description: 'Ajude os noivos a viverem dias inesquecíveis depois da festa.',
      price: 200,
      image_url: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=1200',
      is_available: true
    },
    {
      gift_id: 'preview-casa-nova',
      name: 'Casa Nova',
      description: 'Um presente especial para começar a nova fase com carinho.',
      price: 299.9,
      image_url: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=1200',
      is_available: true
    }
  ]
};

export const TEMPLATE_PREVIEW_COLORS = {
  primary_color: '#2B5443',
  secondary_color: '#BBD3C2',
  text_color: '#2B5443',
  hero_overlay_opacity: 32
};
